export default __webpack_public_path__ + "static/media/warningIcon.2d78bd87.svg";